export function parseName(addresses = "") {
	let files = addresses.split(",").map(address => {
		let lastIndex = address.lastIndexOf("/");
		let name = address.substring(lastIndex + 1);
		return {
			name: name,
			url: address
		};
	});
	return files;
}

export function checkRole(roleName) {
	if (roleName) {
		return "teacher";
	} else {
		return "student";
	}
}



// WEBPACK FOOTER //
// ./src/app/utils/index.js